import { render, staticRenderFns } from "./PaymentAmount.vue?vue&type=template&id=6a950148&scoped=true&"
import script from "./PaymentAmount.vue?vue&type=script&lang=js&"
export * from "./PaymentAmount.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAmount.vue?vue&type=style&index=0&id=6a950148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a950148",
  null
  
)

component.options.__file = "PaymentAmount.vue"
export default component.exports